import { UseFormReset } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Form, FormField } from 'core/components';
import { FormGroupWrapper } from 'core/elements';
import { InputType } from 'core/enums';
import { useFormContext } from 'core/states';
import { PricingProfilePricingType } from 'pricing/enums';
import { IPricingProfile, IPricingProfileForm } from 'pricing/types';

interface IProps {
  pricingProfiles: IPricingProfile[];
  type: PricingProfilePricingType;
  isOpen: boolean;
  onClose: (reset: UseFormReset<IPricingProfileForm>) => void;
  onSubmit: (reset: UseFormReset<IPricingProfileForm>) => (data: IPricingProfileForm) => void;
}

export const UpdatePricingProfilesFormFields = ({
  pricingProfiles,
  type,
  isOpen,
  onClose,
  onSubmit,
}: IProps) => {
  const { watch } = useFormContext();

  const { t } = useTranslation();

  const isSingleProfile = pricingProfiles.length === 1;

  const title =
    type === PricingProfilePricingType.PRICING
      ? t('titleUpdatePricingProfile', { count: pricingProfiles.length })
      : t('titleUpdateCostingProfile', { count: pricingProfiles.length });

  return (
    <Form title={title} isOpen={isOpen} onClose={onClose} onSubmit={onSubmit}>
      {isSingleProfile && (
        <FormField
          name="name"
          type={InputType.TEXT_INPUT}
          inputProps={{
            label: t('labelName'),
          }}
        />
      )}

      <FormField
        name="agreementId"
        type={InputType.TEXT_INPUT}
        inputProps={{
          label: t('labelAgreementId'),
        }}
      />

      <FormGroupWrapper name="validityDates">
        <FormField
          name="startDate"
          type={InputType.DATE_INPUT}
          inputProps={{
            label: t('labelStartDate'),
            maxDate: watch('endDate'),
          }}
        />
        <FormField
          name="endDate"
          type={InputType.DATE_INPUT}
          inputProps={{
            label: t('labelEndDate'),
            minDate: watch('startDate'),
          }}
        />
      </FormGroupWrapper>

      <FormField
        name="shareAccess"
        type={InputType.CHECKBOX}
        inputProps={{
          label: t('messagePricingProfileShareAccess'),
        }}
      />
    </Form>
  );
};
